/**
 * 订单管理 提现
 */
<template>
  <div style="background-color: #F5F5F5">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right" style="background-color: white;">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>提现</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 班级详情 -->
    <el-descriptions class="margin-top" title="我的钱包" :column="5" border style="background-color: white; padding: 10px; border-radius: 5px; height: 17vh;">
      <el-descriptions-item>
        <template slot="label">
          总购卡金额
        </template>
        {{ txInfoItem.gkPrice }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">
          分成比例
        </template>
        {{ txInfoItem.psr }}%
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">
          分成金额
        </template>
        {{ txInfoItem.fcPrice }}
      </el-descriptions-item>

      <el-descriptions-item>
        <template slot="label">
          待提现金额
        </template>
        {{ txInfoItem.dtxPrice }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">
          已提现金额
        </template>
        {{ txInfoItem.ytxPrice }}
      </el-descriptions-item>
    </el-descriptions>


    <div style="background-color: white; padding: 10px; border-radius: 5px; margin-top: 15px; height: 74.8vh; overflow-y: auto">
      <div class="el-descriptions__title">提现记录</div>

      <!-- 搜索筛选  accordion -->
      <el-collapse ref="coll" v-model="activeCollapseNames">
        <el-collapse-item name="search">
          <template slot="title">
            <!-- 搜索区域折叠行 -->
            <div style="display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; width: 100%;" @click.stop="void 0">
              <div style="display: flex; flex-wrap: nowrap; align-items: center;">
                <el-form ref="queryForm" label-width="80px" :inline="true" :model="queryParams" class="user-search">
                  <el-form-item label="搜索：">
                    <el-select size="small" v-model="queryParams.lx" placeholder="请选择类型">
                      <el-option v-for="x in lxList" :label="x.dictLabel" :value="x.dictValue" :key="x.dictValue"></el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item>
<!--                    <el-button size="small" type="primary" icon="el-icon-arrow-down" @click="toggleCollapse">{{ activeCollapseNames.length ? "收起" : "更多" }}</el-button>-->
                    <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
                    <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">提现</el-button>
                  </el-form-item>
                </el-form>
              </div>
            </div>
          </template>

          <!-- 这是折叠的内容区域 -->
          <div
            style="display: flex; flex-wrap: wrap;"
          >
            <el-form
              :model="queryParams"
              ref="queryForm2"
              :inline="true"
              label-width="68px"
            >

            </el-form>
          </div>
        </el-collapse-item>
      </el-collapse>


      <!--列表-->
      <el-table
        ref="multipleTable"
        size="small"
        :data="listData"
        highlight-current-row
        v-loading="loading"
        border
        element-loading-text="拼命加载中"
        style="width: 100%;"
        @selection-change="handleSelectionChange"
        :row-key="(row) => { return row.id }"
      >
<!--        <el-table-column type="selection" width="55" align="center" :reserve-selection="true" />-->
        <el-table-column label="序号" align="center" type="index" :index="indexMethod" width="60"/>
        <el-table-column prop="xm" label="姓名"/>
        <el-table-column prop="dzPrice" label="到账金额"/>
        <el-table-column prop="sxf" label="手续费"/>
        <el-table-column prop="txPrice" label="提现金额"/>
        <el-table-column prop="zfbAccount" label="支付宝账号"/>
        <el-table-column prop="upAccount" label="银联账号"/>
        <el-table-column prop="khh" label="开户行"/>
        <el-table-column prop="khhXm" label="开户人姓名"/>
        <el-table-column prop="createTime" label="申请时间" width="140"/>
        <el-table-column prop="fjUurl" label="附件"/>
        <el-table-column prop="ztMc" label="状态"/>

        <el-table-column align="center" label="操作" width="150">
          <template slot-scope="scope">
            <el-tooltip
              class="item"
              effect="dark"
              content="删除"
              placement="top"
              v-if="scope.row.zt != 1"
            >
              <el-button
                size="mini"
                type="danger"
                icon="el-icon-delete"
                @click="handleDel(scope.$index, scope.row)"
              >
              </el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页组件 -->
      <Pagination v-bind:child-msg="pageparm" @callFather="callFather" style="position: fixed; bottom: 2vh;"></Pagination>
    </div>

    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormShow" width="35%" top="5vh" :close-on-click-modal="false" @click="closeDialog" append-to-body>
      <el-form label-width="100px" ref="form" :model="form" :rules="rules">
        <el-form-item label="提现金额" prop="txPrice">
          <el-input size="small" maxLength="255" v-model="form.txPrice" placeholder="请输入提现金额" @input="formatInportData($event,'10,2','txPrice',form)"></el-input>
        </el-form-item>
        <el-form-item label="到账金额" prop="dzPrice">
          {{ form.txPrice ? form.dzPrice = keepTwoContainZero(form.txPrice - (form.txPrice * (form.sxf/100))) : 0  }}
        </el-form-item>
        <el-form-item label="提现类型" prop="lx">
          <el-select size="small" style="width: 100%" clearable v-model="form.lx" placeholder="请选择提现类型">
            <el-option
              v-for="x in lxList"
              :label="x.dictLabel"
              :value="x.dictValue"
              :key="x.dictValue"
              @click.native="changeLx(x)">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="支付宝账号" prop="zfbAccount" v-if="form.lx == 1">
          <el-input size="small" maxLength="50" v-model="form.zfbAccount" placeholder="请输入支付宝账号"></el-input>
        </el-form-item>
        <el-form-item label="姓名" prop="xm" v-if="form.lx == 1">
          <el-input size="small" maxLength="20" v-model="form.xm" placeholder="请输入姓名"></el-input>
        </el-form-item>

        <el-form-item label="银联账号" prop="upAccount" v-if="form.lx == 2">
          <el-input size="small" maxLength="20" v-model="form.upAccount" placeholder="请输入银联账号"></el-input>
        </el-form-item>

        <el-form-item label="开户行" prop="khh" v-if="form.lx == 2">
          <el-input size="small" maxLength="50" v-model="form.khh" placeholder="请输入开户行"></el-input>
        </el-form-item>

        <el-form-item label="开户人姓名" prop="khhxm" v-if="form.lx == 2">
          <el-input size="small" maxLength="50" v-model="form.khhxm" placeholder="请输入开户人姓名"></el-input>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='closeDialog("edit")'>取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('form')">保存</el-button>
      </div>
    </el-dialog>



  </div>
</template>

<script>
import {formatInportData, timestampToTime} from '../../utils/util'
import Pagination from '../../components/Pagination'
import Template from "../../components/template";

import {deleteOrg, getLearnPlatformList, getMarketingChannelList, saveOrg, updateOrg} from "../../api/userMG";
import {deleteTxById, queryTxInfo, queryTxList, saveTx} from "../../api/order";

export default {
  data() {
    return {
      txInfoItem: {},    // 提现数据

      ids: [],    // 多选框ids
      dateValue: [],
      loading: false, //是显示加载
      editFormShow: false, //控制编辑页面显示与隐藏
      title: '添加',
      form: {},
      rules: {
        txPrice: [
          { required: true, message: '请输入提现金额', trigger: 'blur' }
        ],
        lx: [
          { required: true, message: '请选择提现类型', trigger: 'blur' }
        ],
      },
      // rules表单验证
      queryParams: {
        page: 1,
        size: 10,
      },
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },

      // 查询折叠
      activeCollapseNames: [],
      lxList: [
        { dictLabel: '支付宝', dictValue: 1 },
        { dictLabel: '银行账户', dictValue: 2 },
      ]

    }
  },
  // 注册组件
  components: {
    Template,
    Pagination,
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getdata();
    this.getInfo();
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    formatInportData,
    updateOrg,
    timestampToTime,
    indexMethod(index) {
      return (this.pageparm.currentPage - 1) * this.pageparm.pageSize + index + 1;
    },
    // 查询折叠
    toggleCollapse() {
      this.activeCollapseNames = this.activeCollapseNames.length ? [] : ["search"];
    },

    //四舍五入保留2位小数(不够位数，则用0替补)
    keepTwoContainZero(num) {
      var result = parseFloat(num);
      if (isNaN(result)) {
        result = 0;
      }
      result = Math.round(num * 100) / 100;
      var s_x = result.toString();
      var pos_decimal = s_x.indexOf('.');
      if (pos_decimal < 0) {
        pos_decimal = s_x.length;
        s_x += '.';
      }
      while (s_x.length <= pos_decimal + 2) {
        s_x += '0';
      }
      return s_x;
    },

    // 查询 班级详情
    getInfo() {
      queryTxInfo().then(res => {
        if(res.code == 200) {
          this.txInfoItem = res.data;
        }
      })
    },

    // 类型 单选
    changeLx(item) {
      if (item.dictValue == 1) {
        // 支付宝
        this.rules = {
          txPrice: [
            { required: true, message: '请输入提现金额', trigger: 'blur' }
          ],
          lx: [
            { required: true, message: '请选择提现类型', trigger: 'blur' }
          ],
          zfbAccount: [
            { required: true, message: '请输入支付宝账号', trigger: 'blur' }
          ],
          xm: [
            { required: true, message: '请输入姓名', trigger: 'blur' }
          ],
        }
      } else if (item.dictValue == 2) {
        // 银联
        this.rules = {
          txPrice: [
            { required: true, message: '请输入提现金额', trigger: 'blur' }
          ],
          lx: [
            { required: true, message: '请选择提现类型', trigger: 'blur' }
          ],
          upAccount: [
            { required: true, message: '请输入银联账号', trigger: 'blur' }
          ],
          khh: [
            { required: true, message: '请输入开户行', trigger: 'blur' }
          ],
          khhxm: [
            { required: true, message: '请输入开户人姓名', trigger: 'blur' }
          ],
        }
      }
    },

    // 获取提现历史数据
    getdata() {
      this.loading = true
      /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */
      queryTxList(this.queryParams).then(res => {
        this.loading = false
        if (res.code != 200) {
          this.$message({
            type: 'info',
            message: res.msg
          })
        } else {
          this.listData = res.data.content
          // 分页赋值
          this.pageparm = res.data.pageparm
          this.pageparm.pageSize = 10;
        }
      })
      .catch(err => {
        this.loading = false
        this.$message.error('加载失败，请稍后再试！')
      })
    },
    // 分页插件事件
    callFather(parm) {
      this.queryParams.page = parm.currentPage
      this.queryParams.size = parm.pageSize
      this.getdata()
    },
    // 搜索事件
    search() {
      this.queryParams.page = 1;
      this.getdata()
    },
    // 多选框选中数据
    handleSelectionChange(val) {
      this.ids = val;
    },

    // 显示提现界面
    handleEdit(index, row) {
      this.editFormShow = true
      this.title = '提现'
      this.form = {
        sxf: this.txInfoItem.sxf
      };
    },

    submitForm(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {

          if (Number(this.form.txPrice) > Number(this.txInfoItem.dtxPrice)) {
            this.$message.error('提现金额超出待提现金额，请重新输入');
            return;
          }

          saveTx(this.form).then(res => {
            this.editFormShow = false
            this.loading = false
            if (res.code == 200) {
              this.getdata()
              this.form = {};
              this.rules = {
                txPrice: [
                  { required: true, message: '请输入提现金额', trigger: 'blur' }
                ],
                lx: [
                  { required: true, message: '请选择提现类型', trigger: 'blur' }
                ],
              }
              this.$message({
                type: 'success',
                message: '保存成功！'
              })
            } else {
              this.$message({
                type: 'info',
                message: res.msg
              })
            }
          })
            .catch(err => {
              this.editFormShow = false
              this.loading = false
              this.$message.error(err.response.data.msg)
            })
        } else {
          return false
        }
      })
    },

    // 关闭编辑、增加弹出框
    closeDialog() {
      this.editFormShow = false
    },

    // 格式化日期函数
    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },

    // 删除
    handleDel(index, row) {
      this.$confirm('确定要删除该条记录吗?', '提醒', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          // 删除
          deleteTxById(row.id).then(res => {
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: '删除成功！'
              })
              this.getdata()
            } else {
              this.$message({
                type: 'info',
                message: res.msg
              })
            }
          })
            .catch(err => {
              this.loading = false
              this.$message.error('删除失败，请稍后再试！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除！'
          })
        })
    }


  }
}
</script>

<style scoped>
.user-search {
  margin-top: 10px;
}
.userRole {
  width: 100%;
}
.btnCss {
  margin-top: 10px;
  margin-left: 0px !important;
}

/* 导出 */
.menu-item {
  display: block;
  line-height: 20px;
  text-align: center;
  margin-top: 2px;
}
.menu-item:hover{
  background-color: #66b1ff;
  color: white;
  cursor:pointer;
}
.menu {
  /*height: 35px;*/
  width: 90px;
  position: absolute;
  border: 1px solid #999;
  border-radius: 10px;
  background-color: #f4f4f4;
  padding: 5px 0px;
}

.el-dropdown {
  vertical-align: top;
}
.el-dropdown + .el-dropdown {
  margin-left: 10px;
}
.el-icon-arrow-down {
  font-size: 12px;
}

/deep/ .el-drawer {
  background-color: #F5F5F5 !important;
  padding: 15px !important;
}

/deep/ .el-collapse {
  margin-top: 10px !important;
  border-top: 0px solid #EBEEF5 !important;
  border-bottom: 0px solid #EBEEF5 !important;
}

/deep/ .el-collapse-item__content {
  padding-bottom: 0px;
}

/deep/ .el-collapse-item__arrow{
  display: none;
}

</style>





// WEBPACK FOOTER //
// src/views/order/withdraw.vue